module.exports = "<app-documento-entrada-detalle-list [documento]=\"documento\"></app-documento-entrada-detalle-list>"


//////////////////
// WEBPACK FOOTER
// D:/Proyectos/tpl viejo prueba/eflowTPL/src/app/services/testing/testing.component.html
// module id = ../../../../../src/app/services/testing/testing.component.html
// module chunks = main